import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconBoxes = props => (
  <SvgIcon {...props} viewBox="0 0 17.999998 17.999998">
    <path d="m17 10h-16c-0.55 0-1 0.45-1 1v6c0 0.55 0.45 1 1 1h16c0.55 0 1-0.45 1-1v-6c0-0.55-0.45-1-1-1zm-13 6c-1.1 0-2-0.9-2-2s0.9-2 2-2 2 0.9 2 2-0.9 2-2 2zm13-16h-16c-0.55 0-1 0.45-1 1v6c0 0.55 0.45 1 1 1h16c0.55 0 1-0.45 1-1v-6c0-0.55-0.45-1-1-1zm-13 6c-1.1 0-2-0.9-2-2s0.9-2 2-2 2 0.9 2 2-0.9 2-2 2z" />
  </SvgIcon>
);

export default IconBoxes;



// WEBPACK FOOTER //
// ./src/components/icons/IconBoxes.js